import {
  ITennisResults
} from "@sky-it-livedata/livedata-sports-design-system";
import { isNotEmptyArray, loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";
import errors from "../../utils/errors";
import { ResultsData } from "./types";
import { composeEmptyPlayers } from "./results-utils";

const logger = loggerFactory();

const isValidObject = (obj: ResultsData) =>
  Boolean(obj?.data?.getResultsWidget);

export const transformQuery = (obj: ResultsData): ITennisResults => {
  if (isValidObject(obj)) {
    try {
      const { matches, categoryName, date } = obj?.data?.getResultsWidget;

      return {
        categoryName,
        date,
        matches: matches?.map((match) => {
          return {
            ...match,
            firstPosition: {
              ...match?.firstPosition,
              players: isNotEmptyArray(match?.firstPosition?.players) ? match?.firstPosition?.players : composeEmptyPlayers(categoryName!),
            },
            secondPosition: {
              ...match?.secondPosition,
              players: isNotEmptyArray(match?.secondPosition?.players) ? match?.secondPosition?.players : composeEmptyPlayers(categoryName!),
            },
          }
        })
      } as ITennisResults;
    } catch (error) {
      logger.error(
        "ERROR 4001: transform() error in Results transformer",
        obj
      );
      throw errors.fromCode(4001);
    }
  } else {
    logger.error("ERROR 4000", obj);
    throw errors.fromCode(4000);
  }
};